export const nextChar = (c: string, x: number = 1) => {
  return String.fromCharCode(c.charCodeAt(0) + x);
};
